import { BaseAddNewButton, IncludedCourseDetails } from './index';
import './css/courses-included-section.scss';

export const CoursesIncluded = function ({ courses = [], addCourse, deleteCourse, isParentCourse = false, isRelatedVidCourses = false }) {

  if (isRelatedVidCourses) {
    const headers = ['No.', 'Course ID', 'Title'];
    return (
      <section className="courses-included-section" id="related-vid-courses">
        <h2>Related VID courses</h2>
        <ul className="flex width-full-list read-only flex-auto">
          {headers.map((val) => (
            <li key={val}><b>{val}</b></li>
          ))}
        </ul>
        <div className="read-only-rows-container">
          {courses.map((course, index) => (
            <IncludedCourseDetails
              key={course.moduleId || index}
              index={index}
              isParentCourse={true}
              isReadOnly={true}
              showHeader={false}
              course={course}
            />
          ))}
        </div>
      </section>
    );
  }

  return (
    isParentCourse ? (
      <div className="courses-included-section">
        <h3 className='related-course-title'>Related course <span>(optional)</span></h3>
        {courses.map((course, index) => (
          <IncludedCourseDetails
            key={Math.random() * 1000}
            onDelete={deleteCourse}
            index={index}
            isParentCourse={true}
            course={course}
          />
        ))}
      </div>
    ) : (
      <section className="courses-included-section">
        <h2>Courses included</h2>
        {courses.map((course, index) => (
          <IncludedCourseDetails
            key={Math.random() * 1000}
            onDelete={deleteCourse}
            index={index}
            course={course}
          />
        ))}
        <BaseAddNewButton text="Add a new course" cy="add-new-course-btn" onClick={addCourse} />
      </section>
    )
  );
};
